export * from './offering.service';
import { OfferingService } from './offering.service';
export * from './offering.serviceInterface';
export const APIS = [OfferingService];
